const React = require("react");
const T = require("prop-types");
const RaisedButton = require("material-ui/RaisedButton").default;
const TextField = require("material-ui/TextField").default;
const Paper = require("material-ui/Paper").default;
const IsEmail = require("utils/is-email");

const internals = {};

internals.paperStyle = {
    padding: "3rem",
    margin: "4rem 0"
};

module.exports = class UpdateEmail extends React.Component {
    static propTypes = {
        onSubmit: T.func.isRequired
    };

    constructor() {
        super();

        this.state = {
            email: "",
            confirmEmailHasBlurred: false
        };

        this.emailChanged = this._emailChanged.bind(this);
        this.confirmEmailBlurred = this._confirmEmailBlurred.bind(this);
        this.submit = this._submit.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    _emailChanged(ev, value) {
        this.setState({ email: value });
    }

    _confirmEmailBlurred() {
        this.setState({ confirmEmailHasBlurred: true });
    }

    _submit(ev) {
        const { email } = this.state;

        this.props.onSubmit(email);
        ev.preventDefault();
    }

    render() {
        const { email, confirmEmailHasBlurred } = this.state;

        const errorText =
            confirmEmailHasBlurred && (email === "" || !IsEmail(email));

        const isButtonDisabled = !IsEmail(email);

        return (
            <Paper style={internals.paperStyle}>
                <div>
                    <h1>Need to update your email address?</h1>
                    <p>
                        Enter your email address below and we will update your
                        account.
                    </p>
                    <form onSubmit={this.submit}>
                        <div className="form-group">
                            <TextField
                                hintText="New Email Address"
                                value={this.state.email}
                                onChange={this.emailChanged}
                                onBlur={this.confirmEmailBlurred}
                                errorText={
                                    errorText && "Please enter your email"
                                }
                            />
                        </div>
                        <RaisedButton
                            primary
                            label="Update Email"
                            labelStyle={{
                                textTransform: "inherit"
                            }}
                            onSubmit={this.submit}
                            type="submit"
                            disabled={isButtonDisabled}
                        />
                    </form>
                </div>
            </Paper>
        );
    }
};



// WEBPACK FOOTER //
// ./src/routes/update-email/components/UpdateEmail.js